import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { Captado } from '../domain/captado.model';

export class CaptadoSerializer extends DomainSerializer<Captado> {}
